import React from "react";

const DataMutis2026 = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Dashboard Mudik Gratis 2026"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=136&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDg5MDEzODMzLCJJZGVudGl0eSI6MTM2LCJUb2tlblR5cGUiOjB9.hgQGkTPBbcWtkaCj41jmJH89xmueWaMrTq7N20NfTnM&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataMutis2026;
